import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss']
})
export class CollapseComponent implements OnInit {
  
    arrayComponent: any;
    componentRender: any;
    infoComponent: any;
    constructor() {
  
      this.arrayComponent = [
        {
          id: 'default',
          claseContainer: 'col-12',
          componentRender:
          `
          <div class="accordion accordion-govco" id="EjemploAccordion1">
            <div class="card">
                <div class="card-header row no-gutters" id="headingUno">
                    <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapseUno" aria-expanded="false" aria-controls="collapseUno">
                        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                            <span class="title">Grupo de información #1</span>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                            <div class="btn-icon-close">
                                <span class="label-icon">menos</span>
                                <span class="govco-icon govco-icon-minus"></span>
                                <span class="govco-icon govco-icon-plus"></span>
                            </div>
                        </div>
                    </button>
                </div>
                <div id="collapseUno" class="collapse" aria-labelledby="headingUno" data-parent="#EjemploAccordion1">
                    <div class="card-body bg-color-selago">
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header row no-gutters" id="headingDos">
                    <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapseDos" aria-expanded="false" aria-controls="collapseDos">
                        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                            <span class="title">Grupo de información #2</span>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                            <div class="btn-icon-close">
                                <span class="label-icon">menos</span>
                                <span class="govco-icon govco-icon-minus"></span>
                                <span class="govco-icon govco-icon-plus"></span>
                            </div>
                        </div>
                    </button>
                </div>
                <div id="collapseDos" class="collapse" aria-labelledby="headingDos" data-parent="#EjemploAccordion1">
                    <div class="card-body bg-color-selago">
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header row no-gutters" id="headingTres">
                    <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapseTres" aria-expanded="false" aria-controls="collapseTres">
                        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                            <span class="title">Grupo de información #3</span>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                            <div class="btn-icon-close">
                                <span class="label-icon">menos</span>
                                <span class="govco-icon govco-icon-minus"></span>
                                <span class="govco-icon govco-icon-plus"></span>
                            </div>
                        </div>
                    </button>
                </div>
                <div id="collapseTres" class="collapse" aria-labelledby="headingTres" data-parent="#EjemploAccordion1">
                    <div class="card-body bg-color-selago">
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                </div>
            </div>
          </div>
            `,
          titulo: 'Acordeón GOV.CO General',
          subtitulo: 'Acordeón base de GOV.CO con identificador header de grupo azul oscuro y cuerpo de grupo azul claro'
        },
        {
          id: 'simple',
          claseContainer: 'col-12',
          componentRender:
          `
          <div class="accordion accordion-govco-simple" id="EjemploAccordionSimple1">
            <div class="card">
                <div class="card-header row no-gutters" id="headingSimple-1">
                    <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapseSimple-1" aria-expanded="false" aria-controls="collapseSimple-1">
                        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                            <span class="title">Grupo de información interno #1</span>
                        </div>
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                            <div class="btn-icon-close">
                                <span class="label-icon">cerrar</span>
                                <span class="govco-icon govco-icon-simpled-arrow"></span>
                                <span class="govco-icon govco-icon-simpler-arrow"></span>
                            </div>
                        </div>
                    </button>
                </div>
                <div id="collapseSimple-1" class="collapse" aria-labelledby="headingSimple-1" data-parent="#EjemploAccordionSimple1">
                    <div class="card-body">
                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                </div>
            </div>
          </div>
            `,
          titulo: 'Acordeón Simple',
          subtitulo: 'Acordeón simple en textos azules'
        },
        {
          id: 'anidado',
          claseContainer: 'col-12',
          componentRender:
          `
            <div class="accordion accordion-govco" id="EjemploAccordion-2">
              <div class="card">
                <div class="card-header row no-gutters" id="headingUno">
                  <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                    <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                        <span class="title">Grupo de información #1</span>
                    </div>
                    <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                        <div class="btn-icon-close">
                            <span class="label-icon">menos</span>
                            <span class="govco-icon govco-icon-minus"></span>
                            <span class="govco-icon govco-icon-plus"></span>
                        </div>
                    </div>
                  </button>
                </div>
                <div id="collapse1" class="collapse" aria-labelledby="headingUno" data-parent="#EjemploAccordion-2">
                  <div class="card-body bg-color-selago">
                    <p>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. </p>
                    <div class="accordion accordion-govco-simple accordion-inside-govco" id="EjemploAccordionInterno1">
                      <div class="card">
                        <div class="card-header row no-gutters" id="headingInterno-1">
                          <button class="btn-link row no-gutters collapsed" type="button" data-toggle="collapse" data-target="#collapseInterno-1" aria-expanded="false" aria-controls="collapseInterno-1">
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                              <span class="title">Grupo de información interno #1</span>
                            </div>
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                              <div class="btn-icon-close">
                                <span class="label-icon">cerrar</span>
                                <span class="govco-icon govco-icon-simpled-arrow"></span>
                                <span class="govco-icon govco-icon-simpler-arrow"></span>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div id="collapseInterno-1" class="collapse" aria-labelledby="headingInterno-1" data-parent="#EjemploAccordionInterno1">
                          <div class="card-body">
                            Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            `,
          titulo: 'Acordeón Anidado',
          subtitulo: 'Acordeón GOV.CO general con acordeón simple en su interior'
        },
      ];
  
      this.infoComponent = {
        titulo: 'Acordeón (Collapse)',
        descripcion: 'El .collapse clase indica un elemento plegable (un <div> en nuestro ejemplo); este es el contenido que se muestra o se oculta con un clic de un botón. Para controlar (mostrar / ocultar) el contenido plegable, agregar la data-toggle="collapse" atributo a un <a> o un <button> elemento. A continuación, añadir el data-target="#id" atributo para conectar el botón con el contenido plegable (<div id="demo">) .Nota: Para <a> elementos, se puede utilizar el href atributo en lugar de la data-target de atributos:'
      }
    }
  
    ngOnInit() {
    }
  
    ngAfterViewInit() {
      // this.componentRender = this.exampleInput.nativeElement.innerHTML;
      // this.exampleInput.nativeElement.innerHTML = ""; 
    }
  }
  
  
  
  